import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { NotificationService } from 'src/app/_services/notification.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { ProductService } from '../../_ecomservices/product.service';
import { CategoryCreateComponent } from '../category-create/category-create.component';
import { BrandCreateComponent } from '../brand-create/brand-create.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {SelectionModel} from '@angular/cdk/collections';

@Component({
  selector: 'app-product-create',
  templateUrl: './product-create.component.html',
  styleUrls: ['./product-create.component.css'],

})
export class ProductCreateComponent implements OnInit {

  colorDataSource: MatTableDataSource<any>;  
  colorSelection = new SelectionModel<any>(true, []);

  chartDataSource: MatTableDataSource<any>;

  product_form = new FormGroup({
    id : new FormControl(null),
    prod_type : new FormControl(1, [Validators.required]),
    prod_name : new FormControl('', [Validators.required, Validators.maxLength(255)]),
    sku : new FormControl(''),
    prod_desc : new FormControl('', [Validators.required]),
    regular_price : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    sale_price : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    stock_qty : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    min_order_qty : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    primary_img : new FormControl(null),
    secondary_img : new FormControl(null),
    is_sale : new FormControl(0, [Validators.required]),
    is_returnable : new FormControl(0, [Validators.required]),
    is_cod : new FormControl(0, [Validators.required]),
    product_rating : new FormControl(''),
    color_id : new FormControl(''),
    brand_id : new FormControl(0, [Validators.required]),
    size_chart_id : new FormControl(''),
    product_tag : new FormControl(''),
    product_quality : new FormControl(''),
    pack_qty : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    pack_price : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
  });

  categoryDisplayedColumns: string[] = ['select', 'CategoryName', 'ParentCategory'];
  categoryDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) categoryPaginator: MatPaginator;
  categorySearchKey: string;

  brandDisplayedColumns: string[] = ['select', 'BrandName'];
  brandDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) brandPaginator: MatPaginator;
  brandSearchKey: string;

  primary_img: File = null;
  primaryImagePreview: string | ArrayBuffer | null = null;
  secondary_img: File = null;
  secondaryImagePreview: string | ArrayBuffer | null = null;

  color = 'warm';
  
  checked = false;
  disabled = false;

  // category_list = [];
  // brand_list = [];

  categorySelection = new SelectionModel<any>(true, []);
  selectedBrand: any;

  constructor(public productService: ProductService,
    private dialog: MatDialog,
    private router:Router,
    private loading : LoadingService,
    private notificationService: NotificationService,
  ) {
    this.get_active_colors();
    this.get_size_charts();
   }

  get_active_colors() {
    var result = this.productService.get_active_colors().subscribe(data=> {      
      if(data['status']){
        this.colorDataSource = new MatTableDataSource<any>(data['colors']);
        //console.log(data);
        this.colorDataSource.data.forEach(row => {
          // const cat_check = this.product_variations.find(x=> x.color_id === row.id);
          // if(cat_check){
          //   this.colorSelection.select(row)
          // }
        });
      }
    });
  }

  get_size_charts() {
    var result = this.productService.get_size_charts().subscribe(data=> {      
      if(data['status']){
        this.chartDataSource = new MatTableDataSource<any>(data['data_list']);
        //console.log(data);
        this.chartDataSource.data.forEach(row => {
        });
      }
    });
  }

  categoryApplyFilter() {
    this.categoryDataSource.filter = this.categorySearchKey.trim().toLocaleLowerCase();
  }

  onCategorySearchClear() {
    this.categorySearchKey = "";
    this.categoryApplyFilter();
  }

  brandApplyFilter() {
    this.brandDataSource.filter = this.brandSearchKey.trim().toLocaleLowerCase();
  }

  onBrandSearchClear()
  {
    this.brandSearchKey = "";
    this.brandApplyFilter();
  }

  onSelectPrimaryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.primary_img = file;
      // this.productService.product_form.patchValue({ primary_img: file });      
      //this.productService.product_form.get('primary_img')!.updateValueAndValidity();
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.primaryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectSecondaryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) 
    {
      this.secondary_img = file;
      // this.productService.product_form.patchValue({ secondary_img: file });      
      //this.productService.product_form.get('secondary_img')!.updateValueAndValidity();
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.secondaryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  ngOnInit() {
    this.get_active_category();
    this.get_active_brand();
  }

  onProductFormSubmit(formData: any)
  {    
    console.log(this.product_form.value.is_sale);  
    if(!this.product_form.value.brand_id){
      this.notificationService.warn('Please select product brand');
    }
    else if(this.product_form.valid)
    {
      if(this.categorySelection.selected.length <= 0) {
        this.notificationService.warn('Please select product category');
      }
      else if(!this.primary_img) {
        this.notificationService.warn('Please upload product image');                     
      }
      else{
        this.loading.spin$.next(true);
        this.productService.insert_product(formData, this.primary_img, this.secondary_img, this.categorySelection.selected).subscribe(data=>{
          console.log(data);
          if (data['status']) 
          {
            this.product_form.reset();            
            this.router.navigateByUrl('/ecom/edit-product/' + data['product_id']);
            this.loading.spin$.next(false);
            this.notificationService.success(data['message']);                     
          } 
          else
          {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }

  get_active_category() {
    var result = this.productService.get_active_category().subscribe(data=> {
      this.categoryDataSource = new MatTableDataSource<any>(data['category_list']);
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllCategorySelected() {
    const numSelected = this.categorySelection.selected.length;
    const numRows = this.categoryDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllCategorySelected() ?
        this.categorySelection.clear() :
        this.categoryDataSource.data.forEach(row => this.categorySelection.select(row));
  }

  get_active_brand() {
    var result = this.productService.get_active_brand().subscribe(data=> {
      // this.brand_list = data['brand_list'];
      this.brandDataSource = new MatTableDataSource<any>(data['brand_list']);
      this.brandDataSource.paginator = this.brandPaginator;
      //console.log(this.brand_list);
    });
  }

  onBrandSelectionChange(row: any) {
    this.product_form.controls['brand_id'].setValue(this.selectedBrand.id);
  }

  onCreateCategory()
  {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(CategoryCreateComponent, matDialogConfig).afterClosed().subscribe(res=>{
      this.get_active_category();
    });
  }

  onCreateBrand(){
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    this.dialog.open(BrandCreateComponent, matDialogConfig).afterClosed().subscribe(res=>{
      this.get_active_brand();
    });

  }

  


}
